<template>
  <div>
    <v-card color="grey lighten-5" outlined class="mt-5">
      <v-data-table
        class="transparent"
        disable-pagination
        hide-default-footer
        :headers="headers"
        :items="conditional.then"
      >
        <template v-slot:item="{ index, item }">
          <tr>
            <td>
              {{ item.label }}
            </td>
            <td>
              <span v-if="item.displayValue">{{
                item.displayValue.readableText
                  ? item.displayValue.readableText
                  : item.displayValue
              }}</span>
              <span v-else class="grey--text font-italic">(N/A)</span>
            </td>
            <td class="text-right">
              <v-btn
                @click="conditional.then.splice(index, 1)"
                color="primary"
                outlined
                small
                >Remove</v-btn
              >
            </td>
          </tr>
        </template>
        <template
          v-slot:footer
          v-if="!showActionForm && optionListRemaining.length"
        >
          <div>
            <v-divider> </v-divider>
            <div class="text-right pa-3">
              <v-btn
                color="primary"
                elevation="0"
                small
                @click="showActionForm = true"
                >Add Action</v-btn
              >
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-card outlined v-if="showActionForm && optionListRemaining.length">
      <v-card-title> Add Action </v-card-title>
      <v-card-text>
        <div>
          <v-select
            :hint="
              !attributeCanSetValue
                ? `This attribute does not have a 'Set Value' option, as it is an organization-specific item select.`
                : ''
            "
            :items="optionListRemaining"
            item-text="label"
            item-value="id"
            persistent-hint
            placeholder="Action..."
            return-object
            v-model="newAction"
          ></v-select>
          <attribute-component
            :attributeMap="newAction"
            :configMap="attributeMap"
            :disabled="!newAction"
            :entityName="entityName"
            attributeName="value"
            placeholder="Value..."
            v-if="newAction.id === 'setValue'"
          ></attribute-component>
        </div>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn
          @click="showActionForm = false"
          class="mr-1"
          color="grey darken-2"
          outlined
          small
          >Cancel</v-btn
        >
        <v-btn
          @click="addAction"
          color="primary"
          :disabled="
            !newAction.id ||
            (newAction.id === 'setValue' && !newAction.valueDefault)
          "
          elevation="0"
          small
          >Add action</v-btn
        >
      </v-card-actions>
    </v-card>

    <div></div>
  </div>
</template>

<script>
import { cloneDeep, get, keyBy } from "lodash";
import { mapActions, mapState } from "vuex";

import AttributeComponent from "./AttributeComponent";

import formElementMixin from "./formElementMixin";
import resolver from "@/lib/resolver";

export default {
  components: {
    AttributeComponent,
  },
  computed: {
    optionList() {
      const { optionListBase, attributeCanSetValue } = this;
      return attributeCanSetValue
        ? optionListBase.concat([{ id: "setValue", label: "Set Value" }])
        : optionListBase;
    },
    optionListRemaining() {
      const { optionList } = this;

      const actionList = get(this, "conditional.then");

      if (!Array.isArray(actionList) || !actionList.length) {
        return optionList;
      }

      const actionIdList = actionList.map(({ id }) => id);

      return optionList.filter(({ id }) => !actionIdList.includes(id));
    },
    attributeCanSetValue() {
      const { attributeMap: attribute } = this;
      if (!attribute || !attribute.fkExists || !attribute.fkName) {
        return true;
      }
      const entity = keyBy(this.entityTypeList, "name")[attribute.fkName];

      if (!entity) {
        return true;
      }

      return !entity.isOrgSpecific;
    },
    ...mapState({
      entityTypeList: state => state.entity.list,
    }),
  },
  async created() {
    try {
      await this.loadEntityTypeList({ reload: false });
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: "Error loading data from server" });
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Action",
          value: "action",
        },
        {
          text: "Value",
          value: "value",
        },
        {
          text: "",
        },
      ],
      inputRuleList: [
        v =>
          (v !== undefined && v !== null && `${v}`.length > 0) ||
          (Array.isArray(v) && v.length > 0) ||
          `Required.`,
      ],
      newAction: {},
      optionListBase: [
        { id: "disable", label: "Disable Input" },
        { id: "require", label: "Required for Completion" },
        { id: "show", label: "Show" },
      ],
      showActionForm: false,
    };
  },
  methods: {
    async addAction() {
      const { newAction } = this;

      const actionList = get(this, "conditional.then");

      let resolvedValue;
      try {
        resolvedValue = await resolver.resolveFk(
          newAction.valueDefault,
          this.attributeMap
        );
      } catch (e) {
        console.error(e);
      }

      newAction.displayValue = resolvedValue;

      if (!Array.isArray(actionList)) {
        this.$set(this.conditional, "then", [newAction]);
        this.newAction = {};
        this.showActionForm = false;
        return;
      }

      this.conditional.then.push(cloneDeep(newAction));

      this.newAction = {};
      this.showActionForm = false;
    },
    get,
    ...mapActions({
      loadEntityTypeList: "entity/list",
    }),
  },
  mixins: [formElementMixin],
  props: {
    conditional: {
      required: true,
      type: Object,
    },
    counter: {},
    hint: {},
    optionConfig: {},
    rules: {},
    entityName: {},
    mode: {
      default: "create",
      type: String,
      validator: function (value) {
        return ["create", "update"].includes(value);
      },
    },
  },
};
</script>
